export default __webpack_public_path__ + "static/media/1.cab4f72c.png";